import { lang } from '../../assets/lang'
import { buttonTypes } from '../../data'
import { getSelectOptionsFromArrayOfObjects } from '../../functions/utils'

export const buttonHtml =
'<div id="button-button-text-group" class="form-group text-left mt-4">' + 
  '<label for="button-button-text">' + lang.button_html_label_button_text + '</label>' +
  '<input type="text" class="form-control" id="button-button-text" aria-describedby="button-button-text-help">' +
'</div>' +

'<div class="form-group text-left mt-2">' +
  '<label for="button-button-type">' + lang.button_html_label_button_type + '</label>' +
  '<select id="button-button-type" class="form-control select2">' +
    '<option value="" >' + lang.button_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(buttonTypes) +
  '</select>' +
'</div>' +

'<div id="button-type-postback-group" class="button-onDemand-field form-group text-left mt-2 d-none">' + 
  '<label for="button-type-postback">' + lang.button_html_label_postback_id + '</label>' +
  '<select id="button-type-postback" class="form-control select2">' +
    '<option value="" selected>' + lang.button_html_title_select + '</option>' +
  '</select>' +
'</div>' +

'<div id="button-type-weburl-group" class="button-onDemand-field form-group text-left mt-2 d-none">' + 
  '<label for="button-type-weburl">' + lang.button_html_label_web_url + '</label>' +
  '<input type="text" class="form-control" id="button-type-weburl" aria-describedby="button-type-weburl-help">' +
'</div>' +

'<div id="button-type-call-group" class="button-onDemand-field form-group text-left mt-2 d-none">' + 
  '<label for="button-type-call">' + lang.button_html_label_mobile + '</label>' +
  '<input type="text" class="form-control" id="button-type-call" aria-describedby="button-type-call-help">' +
'</div>' +

'<div id="button-type-webview-group" class="button-onDemand-field form-group text-left mt-2 d-none">' + 
  '<label for="button-type-webview">' + lang.button_html_label_webview_url + '</label>' +
  '<input type="text" class="form-control" id="button-type-webview" aria-describedby="button-type-webview-help">' +
'</div>'